import { z } from 'zod';

import { apiSuccess, apiList, parseAdminApiResponse } from '@services/apiSchemas';

import { adminApiFetch } from './apiService';

// ============================================================
// Schemas — 對齊 app/controllers/api/admin/v1/merchant_inventory_types_controller.rb
// admin 控制器僅有 `index` 與 `update`（建立 / 刪除歸 operator 範圍）。
// ============================================================

const InventoryTypeRefSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  full_name: z.string(),
}).passthrough();

// `index` (render_array_list) / `update` 共用 shape — sit.as_json
// 含 inventory_type 關聯。其餘 merchant_inventory_types 表欄位走 passthrough。
const AdminMerchantInventoryTypeSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  inventory_type_id: z.string(),
  inventory_type: InventoryTypeRefSchema,
  expiration_mechanism: z.string().nullable(),
  expiration_ratio: z.number().nullable(),
  days_before_expiration: z.number().nullable(),
  enabled: z.boolean().nullable(),
  expiration_notification_enabled: z.boolean().nullable(),
  expiration_notification_days: z.number().nullable(),
  ignore_sales_channel: z.boolean().nullable(),
  inventory_age_alert_days: z.number().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
}).passthrough();

// ============================================================
// Exported types
// ============================================================

export type AdminMerchantInventoryType = z.infer<typeof AdminMerchantInventoryTypeSchema>;

// ============================================================
// Service
// ============================================================

interface FetchListParams {
  since_id?: string;
  page_size?: number;
  [key: string]: unknown;
}

export const merchantInventoryTypeService = {
  // 列表
  fetchList: async (params: FetchListParams = {}) => {
    const queryParams = new URLSearchParams();
    if (params.since_id) queryParams.append('since_id', String(params.since_id));
    if (params.page_size) queryParams.append('page_size', String(params.page_size));
    // 可添加其他過濾參數

    const response = await adminApiFetch(`merchant_inventory_types?${queryParams.toString()}`, { method: 'GET' });
    return parseAdminApiResponse(response, apiList(AdminMerchantInventoryTypeSchema));
  },

  // 更新
  update: async (id: string, data: Record<string, unknown>) => {
    const response = await adminApiFetch(`merchant_inventory_types/${id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return parseAdminApiResponse(response, apiSuccess(AdminMerchantInventoryTypeSchema));
  },
};
export default merchantInventoryTypeService;
